import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { ContextMenuModule } from 'ngx-contextmenu';
import { dashboardRouting } from 'app/dashboard/dashboard.routes';
import { ShipmentItemService } from './shipmentItem.service';
import { MatTableModule, MatCheckboxModule, MatPaginatorModule, MatSortModule } from '@angular/material';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		dashboardRouting,
		ReactiveFormsModule,
		ContextMenuModule,
		MatTableModule,
		MatCheckboxModule,
		MatPaginatorModule,
		MatSortModule
	],
	declarations: [
	],
	providers: [
		ShipmentItemService
	],
})
export class ShipmentItemModule { }
